<template>
    <breadcrumbs class="mb-3" />
    <v-tabs v-model="tab">
        <v-tab v-if="isShowVat" value="vats">{{ $t('sales_settings_tabs.vat') }}</v-tab>
        <v-tab v-if="authStore.isTourOperator" value="online_payments">{{ $t('online_payments') }}</v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
        <v-tabs-window-item value="vats">
            <SecondLevelTabs
                v-if="secondLevelVatTabs.length"
                :tabs="secondLevelVatTabs"
                translation-key="vat_settings_tabs"
            >
                <template v-slot:vat_plans>
                    <VatTable />
                </template>
            </SecondLevelTabs>
        </v-tabs-window-item>
        <v-tabs-window-item value="online_payments">
            <OnlinePaymentsTable />
        </v-tabs-window-item>
    </v-tabs-window>
</template>

<script setup lang="ts">
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    const tab = ref()
    const secondLevelVatTabs = ref(['vat_plans'])

    const isShowVat = computed(() => {
        return runtimeStore.getCRMOption('asp.option.enable.vat') && isTourOperator.value
    })

    const isTourOperator = computed(() => {
        return authStore.isTourOperator
    })
</script>
